const tooltips = document.querySelectorAll('.tooltip');
const tooltipsQuestions = document.querySelectorAll('.tooltip__question');
const tooltipsClose = document.querySelectorAll('.tooltip__modal__close');

const closeTooltip = () => {
  const openTooltips = document.querySelectorAll('.tooltip.is-active');
  openTooltips.forEach((tooltip) => {
    tooltip.classList.remove('is-active');
  });
};

const tooltipToggle = (element, tooltipClose, tooltipElem) => {
  element.forEach((el) => {
    el.addEventListener('click', (ev) => {
      const parentElem = ev.target.closest('.tooltip');

      closeTooltip();

      if (!parentElem.classList.contains('is-active')) {
         parentElem.classList.add('is-active');
      }
    });
  });

  tooltipClose.forEach((el) => {
    el.addEventListener('click', (ev) => {
      const parentElem = ev.target.closest('.tooltip');
      parentElem.classList.remove('is-active');
    });
  });

  tooltipElem.forEach((tooltip) => {
    document.addEventListener('click', (ev) => {
      const clickInside = tooltip.contains(ev.target);

      if (!clickInside) {
        tooltip.classList.remove('is-active');
      }
    });
  });
};

tooltipToggle(tooltipsQuestions, tooltipsClose, tooltips);
